import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { RadioButtonModule } from "primeng/radiobutton";

import { RadioButtonComponent } from './radio.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RadioButtonModule
  ],
  declarations: [RadioButtonComponent],
  exports: [RadioButtonComponent]
})
export class ndRadioButtonModule { }
